import React from 'react';
import { useTranslation } from 'react-i18next';

const DocumentUploader = ({
  documentType,
  image,
  onUploadClick,
  inputRef,
  onFileSelect,
  showReUpload,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="d-flex flex-row justify-content-between">
        <span className="fw-bold color-heading my-2">{documentType}</span>
        {showReUpload && (
          <span
            className="fw-bold color-danger my-2 cursor-pointer"
            onClick={onUploadClick}
          >
            {`${t("common.reUpload")}`}
          </span>
        )}
      </div>
      
      <div
        className="placeholder front d-flex flex-row justify-content-center align-items-center w-100 py-2"
        onClick={onUploadClick}
      >
        {image ? (
          <img
            className="border-radius-12"
            src={image}
            alt={`Captured ${documentType}`}
            style={{
              width: "100%",
              height: "203px",
              objectFit: "cover",
            }}
          />
        ) : (
          <div className="box d-flex flex-column gap-2">
            <i className="pi pi-upload color-primary"></i>
            <span className="fw-bold color-primary">{`${t("common.uploadPhoto")}`}</span>
          </div>
        )}
      </div>

      <input
        type="file"
        ref={inputRef}
        accept="image/*"
        style={{ display: "none" }}
        onChange={onFileSelect}
      />
    </>
  );
};

export default DocumentUploader;